export default class CaseDrool {
    public channel: string = "CustomerSelfService";
    public caseSubType: string = '';
    public caseSubTypeCategory: string = '';
    public landLord: string = '';
    public tenancyType: string = '';
    public caseCategory: string = '';
  }